import { MutableRefObject, useCallback, useEffect, useMemo } from 'react'

import { useDeleteNotification } from 'modulesCommon/Notifications/services/useDeleteNotifications'

import { useOnScreen } from 'shared/hooks'
import { TNotifications } from 'modulesCommon/Notifications/types'
import { TStory } from '../../components/Story'

export const useNewTag = (postRef: MutableRefObject<null>, post: TStory, notifications: TNotifications[]) => {
  const isVisible = useOnScreen(postRef)
  const { onDeleteNotifications } = useDeleteNotification()

  const deleteNotificationsHandler = useCallback(() => {
    const postNotification = notifications.find((notification) => notification.story_id === post.id)

    if (postNotification?.id && postNotification?.notification_type) {
      onDeleteNotifications([{ id: postNotification.id, notification_type: postNotification.notification_type }])
    }
  }, [onDeleteNotifications, notifications, post.id])

  const isExistInNotifications = useMemo(
    () => notifications.some(({ story_id }) => story_id === post.id),
    [post.id, notifications]
  )
  useEffect(() => {
    let timeout: NodeJS.Timeout
    if (isVisible && isExistInNotifications) {
      timeout = setTimeout(deleteNotificationsHandler, 3000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [deleteNotificationsHandler, isExistInNotifications, isVisible])

  return { isExistInNotifications, deleteNotificationsHandler }
}
